import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';

const GermanHeadquarters = () => (
  <div className="pb-6 border-b border-slate-700">
    <h3 className="text-xl font-semibold text-white mb-4">
      Floria Maler & Lackierer
    </h3>
    <div className="space-y-4">
      <div className="flex items-start gap-3">
        <MapPin className="w-5 h-5 text-purple-400 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-purple-400 mb-1">Hauptsitz Deutschland</div>
          <div className="text-slate-300">
            Aixheimerstrasse 50/4<br />
            78554 Aldingen<br />
            Baden-Württemberg<br />
            Deutschland
          </div>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <Phone className="w-5 h-5 text-purple-400 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-white mb-1">Telefon</div>
          <div className="space-y-1">
            <a href="tel:015901978718" className="text-purple-400 hover:text-purple-300 transition-colors block">
              0159.01978718
            </a>
            <a href="tel:015758183212" className="text-purple-400 hover:text-purple-300 transition-colors block">
              0157.58183212
            </a>
          </div>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <div className="w-5 h-5 text-purple-400 flex-shrink-0 mt-1 flex items-center justify-center font-bold text-sm">
          ID
        </div>
        <div>
          <div className="font-semibold text-white mb-1">Umsatzsteuer-ID</div>
          <div className="text-slate-300">DE319110250</div>
        </div>
      </div>

      <div className="flex items-start gap-3">
        <Clock className="w-5 h-5 text-purple-400 flex-shrink-0 mt-1" />
        <div>
          <div className="font-semibold text-white mb-1">Öffnungszeiten</div>
          <div className="text-slate-300 space-y-1">
            <div>Montag - Freitag: 07:00 - 18:00</div>
            <div>Samstag: 08:00 - 16:00</div>
            <div>Sonntag: Notdienst verfügbar</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default GermanHeadquarters;
